<template>
  <article class="layout-section">
    <div class="rte" v-html="wp.content" />
  </article>
</template>

<script>
export default {
  name: 'WritingIndex',
  inject: ['wp']
}
</script>
